import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import { t } from '../../../i18n/translate.js';
import '../../../i18n/i18n.js';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import PollManager from '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import '../../../services/ipcWeb/ipcService.js';
import { usePrevious, getFirmwareLogsAsync, getFirmwareStatusAsync, shouldStopPollAndShowError, getCalculatedPercent, getCalculatedUpgradeState, notifyContinueToPollFailure, getFailedUpgradeState, pollFirmwareUpgradeLogsAsync, startFirmwareUpgradeAsync } from './FirmwareUpgradeUtils.js';

var useFirmwareUpgrade = function useFirmwareUpgrade(giid, client) {
  var key = "firmwareUpgrade-".concat(giid);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPolling = _useState2[0],
    setIsPolling = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    firmwareStatus = _useState4[0],
    setFirmwareStatus = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    firmwareLogs = _useState6[0],
    setFirmwareLogs = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    percentage = _useState8[0],
    setPercentage = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    upgradeState = _useState10[0],
    setUpgradeState = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    warning = _useState12[0],
    setWarning = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    success = _useState16[0],
    setSucces = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    failure = _useState18[0],
    setFailure = _useState18[1];
  var oldLogs = usePrevious(firmwareLogs);

  // get the initial firmware status and logs
  useEffect(function () {
    if (giid) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var status, logSearch;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getFirmwareStatusAsync(giid, client);
              case 2:
                status = _context.sent;
                setFirmwareStatus(status);
                _context.next = 6;
                return getFirmwareLogsAsync(giid, client);
              case 6:
                logSearch = _context.sent;
                setFirmwareLogs(logSearch);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, [giid]);
  var startPoll = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$pollFirmwareUp, done, failed;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsPolling(true);
              _context2.next = 3;
              return pollFirmwareUpgradeLogsAsync(giid, key, client, setFirmwareLogs);
            case 3:
              _yield$pollFirmwareUp = _context2.sent;
              done = _yield$pollFirmwareUp.done;
              failed = _yield$pollFirmwareUp.failed;
              setSucces(done);
              setFailure(failed);
              setIsPolling(false);
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function startPoll() {
      return _ref2.apply(this, arguments);
    };
  }();
  var startUpgrade = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var result;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return startFirmwareUpgradeAsync(giid, client);
            case 2:
              result = _context3.sent;
              if (result.upgradeWasInitiated) {
                startPoll();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function startUpgrade() {
      return _ref3.apply(this, arguments);
    };
  }();
  var retryUpgrade = function retryUpgrade() {
    setError(false);
    setFailure(false);
    setFirmwareLogs([]);
    startUpgrade();
  };
  var isUpgradeOngoing = function isUpgradeOngoing(fwStatus) {
    var status = fwStatus.status,
      gateways = fwStatus.gateways;
    return status === 'UPDATING_TO_REQUESTED_FIRMWARE' || gateways.some(function (gw) {
      return gw.status === 'UPDATING_TO_REQUESTED_FIRMWARE';
    });
  };

  // check if we can start the upgrade
  useEffect(function () {
    if (firmwareStatus) {
      var upgradeable = firmwareStatus.upgradeable;
      var canStartUpgrade = upgradeable && !isPolling && !shouldStopPollAndShowError(firmwareLogs) && !isUpgradeOngoing(firmwareStatus);
      if (isUpgradeOngoing(firmwareStatus) && !isPolling) {
        startPoll();
      }
      if (canStartUpgrade) {
        startUpgrade();
      }
    }
  }, [firmwareStatus]);

  // update UI
  useEffect(function () {
    if (firmwareLogs.length > 0 && isPolling && oldLogs && JSON.stringify(oldLogs) !== JSON.stringify(firmwareLogs)) {
      setPercentage(getCalculatedPercent(firmwareLogs));
      setUpgradeState(t(getCalculatedUpgradeState(firmwareLogs)));
    }
    if (notifyContinueToPollFailure(firmwareLogs)) {
      setWarning(t(getFailedUpgradeState(firmwareLogs)));
    }
    if (shouldStopPollAndShowError(firmwareLogs)) {
      setError(t(getFailedUpgradeState(firmwareLogs)));
      setIsPolling(false);
    }
  }, [firmwareLogs, isPolling, oldLogs]);

  // clean Up
  useEffect(function () {
    return function () {
      setError(false);
      setFirmwareLogs([]);
      PollManager.cancel(key);
    };
  }, []);
  return {
    success: success,
    failure: failure,
    isPolling: isPolling,
    percentage: percentage,
    upgradeState: upgradeState,
    warning: warning,
    error: error,
    retryUpgrade: retryUpgrade,
    canUpgrade: Boolean(firmwareStatus === null || firmwareStatus === void 0 ? void 0 : firmwareStatus.upgradeable)
  };
};

export { useFirmwareUpgrade };
